import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ReactNumberFormat from 'react-number-format';

const NumberFormat = ({ invalid, ...props }) => (
  <ReactNumberFormat
    {...props}
    className={classNames('forms-Input', {
      [props.className]: props.className,
      'is-invalid': invalid
    })}
  />
);

NumberFormat.defaultProps = {
  className: null,
  invalid: false
};

NumberFormat.propTypes = {
  className: PropTypes.string,
  invalid: PropTypes.bool
};

export default NumberFormat;
